enum QBDResourceTypesEnum {
    CUSTOMER = "Customer",
    CATALOG_ITEM = "Catalog_Item",
    SALES_ORDER = "Sales_Order",
    INVOICE = "INVOICE",
    PURCHASE_ORDER = "PURCHASE_ORDER",
}

export default QBDResourceTypesEnum;
